import { createSlice } from "@reduxjs/toolkit";
import { AviabookingReferenceState } from "./types";
import { fetchAircraft, fetchAirlines, fetchAirports, fetchCountries } from "./aviabooking-reference-thunk";
import { ErrorType } from "@/shared/types";

const initialState: AviabookingReferenceState = {
    countries: [],
    countriesMap: {},
    isCountriesLoading: false,
    isCountriesFirstLoad: true,
    countriesError: null,

    airlines: [],
    airlinesMap: {},
    isAirlinesLoading: false,
    isAirlinesFirstLoad: true,
    airlinesError: null,

    aircraft: [],
    aircraftMap: {},
    isAircraftLoading: false,
    isAircraftFirstLoad: true,
    aircraftError: null,
    
    airports: [],
    airportsMap: {},
    isAirportsLoading: false,
    isAirportsFirstLoad: true,
    airportsError: null
}

const aviabookingSlice = createSlice({
    name: 'aviabookingReference',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchAircraft.pending, (state) => {
            state.isAircraftLoading = true
        })
        builder.addCase(fetchAircraft.fulfilled, (state, action) => {
            state.isAircraftLoading = false
            state.aircraft = action.payload
            state.aircraftError = null
            state.isAircraftFirstLoad = false
            action.payload.forEach((aircraft) => {
                state.aircraftMap = {...state.aircraftMap, [aircraft.code]: aircraft }
            })
        })
        builder.addCase(fetchAircraft.rejected, (state, action) => {
            state.isAircraftLoading = false
            state.aircraftError = action.payload as ErrorType
        })
        builder.addCase(fetchAirlines.pending, (state) => {
            state.isAirlinesLoading = true
        })
        builder.addCase(fetchAirlines.fulfilled, (state, action) => {
            state.isAirlinesLoading = false
            state.airlines = action.payload
            state.airlinesError = null
            state.isAirlinesFirstLoad = false
            action.payload.forEach((airline) => {
                state.airlinesMap = {...state.airlinesMap, [airline.code]: airline }
            })
        })
        builder.addCase(fetchAirlines.rejected, (state, action) => {
            state.isAirlinesLoading = false
            state.airlinesError = action.payload as ErrorType
        })
        builder.addCase(fetchCountries.pending, (state) => {
            state.isCountriesLoading = true
        })
        builder.addCase(fetchCountries.fulfilled, (state, action) => {
            state.isCountriesLoading = false
            state.countries = action.payload
            state.countriesError = null
            state.isCountriesFirstLoad = false
            action.payload.forEach((country) => {
                state.countriesMap = {...state.countriesMap, [country.code]: country }
            })
        })
        builder.addCase(fetchCountries.rejected, (state, action) => {
            state.isCountriesLoading = false
            state.countriesError = action.payload as ErrorType
        })
        builder.addCase(fetchAirports.pending, (state) => {
            state.isAirportsLoading = true
        })
        builder.addCase(fetchAirports.fulfilled, (state, action) => {
            state.isAirportsLoading = false
            state.airports = action.payload
            state.airportsError = null
            state.isAirportsFirstLoad = false
            action.payload.forEach((airport) => {
                state.airportsMap = {...state.airportsMap, [airport.code]: airport }
            })
        })
        builder.addCase(fetchAirports.rejected, (state, action) => {
            state.isAirportsLoading = false
            state.airportsError = action.payload as ErrorType
        })
    },
})

export default aviabookingSlice.reducer